export default __webpack_public_path__ + "static/studio2-28cc273f4158ce992d77c7dd63e64fbc.png";